import { Body } from "./Body";
import { Footer } from "./Footer";

const ExtractionConfigurationStep = {
  Body,
  Footer,
  title: 'Extraction configuration'
};

export { ExtractionConfigurationStep };